import { Autocomplete, AutocompleteRenderOptionState, Popper, TextField } from '@mui/material'
import { FieldContainer } from '../functional'
import { useCallback, useRef } from 'react'

interface AutoCompleteSelectFieldProps {
   name: string
   options: any[]
   placeholder?: string
   label?: string
   renderOption: (
      props: React.HTMLAttributes<HTMLLIElement>,
      option: any,
      state: AutocompleteRenderOptionState,
   ) => JSX.Element
   className?: string
   highlight?: boolean
}

const AutoCompleteSelectField: React.FC<AutoCompleteSelectFieldProps> = (
   props: AutoCompleteSelectFieldProps,
) => {
   const { name, label, placeholder, options, highlight, renderOption } = props
   const fieldContainerRef = useRef(null)
   const PopperComponent = useCallback((props: any) => {
      return (
         <Popper
            {...props}
            anchorEl={fieldContainerRef.current}
            container={document.querySelector('dialog') || undefined}
         />
      )
   }, [])
   return (
      <FieldContainer name={name} highlight={highlight}>
         {(fieldProps) => {
            return (
               <>
                  <Autocomplete
                     renderOption={renderOption}
                     options={options}
                     ref={fieldContainerRef}
                     value={fieldProps.value.value}
                     onChange={(_, value) =>
                        fieldProps.onChange({
                           target: { name, value: value ? value.value : '' },
                        })
                     }
                     onBlur={fieldProps.onBlur}
                     renderInput={(params) => (
                        <TextField
                           {...params}
                           label={label}
                           placeholder={placeholder}
                           value={fieldProps.value.value}
                           helperText={fieldProps.error && fieldProps.helperText}
                           error={fieldProps.error}
                           name={name}
                        />
                     )}
                     PopperComponent={PopperComponent}
                  />
               </>
            )
         }}
      </FieldContainer>
   )
}

export default AutoCompleteSelectField
